import React, { useEffect, useRef } from 'react'
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useForm, setValue } from "react-hook-form";
import * as actions from '../actions/secmasteractions'
import NavBar from '../../../components/NavBar';
import SideNav from '../../../components/SideNav';
import LeftSideMenu from '../../../components/newdashboardcomponent/LeftSideMenu';
import TopBar from '../../../components/newdashboardcomponent/TopBar';
import DashboardTitle from '../../../components/DashboardTitle';
import Footer from '../../../components/Footer';

export default function GroupMenus() {

    const state = useSelector(state => state.secmasterReducer);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    let groupMenus = state.groupMenus;
    let menusListing = state.menusListing;
    let groupsListing = state.groupsListing;
    let groupmenusListing = state.groupmenusListing;
    let modulesListing = state.modulesListing;
    let userBranchesListing = state.userBranchesListing;



    const onResetGroupMenusSearch = () => {
        navigate('');
        resetMenusSearch();
        resetGroupsSearch();
        resetGroupMenusSearch();
        resetModulesSearch();
        resetUserBranchesSearch();
        dispatch(actions.clearGroupMenuParams());
    }

    const { register: registerMenusSearch,
        reset: resetMenusSearch, handleSubmit: onSubmitData, setValue: setMenusSearchValue, watch: watchMenusSearch, formState: { errors: errorsMenusSearch } } = useForm();

    const { register: registerGroupsSearch,
        reset: resetGroupsSearch, handleSubmit: handleGroupsSubmitData, setValue: setGroupsSearchValue, watch: watchGroupsSearch, formState: { errors: errorsGroupsSearch } } = useForm();

    const { register: registerGroupMenusSearch,
        reset: resetGroupMenusSearch, handleSubmit: handleGroupMenusSubmitData, setValue: setGroupMenusSearchValue, watch: watchGroupMenusSearch, formState: { errors: errorsGroupMenusSearch } } = useForm();

    const { register: registerModulesSearch,
        reset: resetModulesSearch, handleSubmit: handleModulesSubmitData, setValue: setModulesSearchValue, watch: watchModulesSearch, formState: { errors: errorsModulesSearch } } = useForm();

    const { register: registerUserBranchesSearch,
        reset: resetUserBranchesSearch, handleSubmit: handleUserBranchesSubmitData, setValue: setUserBranchesSearchValue, watch: watchUserBranchesSearch, formState: { errors: errorsUserBranchesSearch } } = useForm();


    const handleMenusSearch = (e) => { }
    const handleGroupsSearch = (e) => { }
    const handleGroupMenusSearch = (e) => { }
    const handleModulesSearch = (e) => { }
    const handleUserBranchesSearch = (e) => { }


    const onAddNewGroupMenus = async () => {

    }

    const onErrorMenu = (errorsMenusSearch, e) => console.log(errorsMenusSearch, e);

    const onErrorGroup = (errorsGroupsSearch, e) => console.log(errorsGroupsSearch, e);

    const onErrorGroupMenu = (errorsGroupMenusSearch, e) => console.log(errorsGroupMenusSearch, e);

    const onErrorModule = (errorsModulesSearch, e) => console.log(errorsModulesSearch, e);

    const onErrorUserBranch = (errorsUserBranchesSearch, e) => console.log(errorsUserBranchesSearch, e);


    const onCollapseSearch = () => {

    }
    useEffect(() => {
        dispatch(actions.getAllMenus());
    }, []);

    useEffect(() => {
        dispatch(actions.getAllGroups());
    }, []);

    useEffect(() => {
        dispatch(actions.getAllGroupMenus());
    }, []);
    useEffect(() => {
        dispatch(actions.getAllModules());
    }, []);

    useEffect(() => {
        dispatch(actions.getAllUserBranches());
    }, []);

    const onMenusSubmit = async (data, e) => {

        await dispatch(actions.getAllMenus());
    }

    const onGroupsSubmit = async (data, e) => {

        await dispatch(actions.getAllGroups());
    }

    const onGroupMenusSubmit = async (data, e) => {

        await dispatch(actions.getAllGroupMenus());
    }

    const onModulesSubmit = async (data, e) => {

        await dispatch(actions.getAllModules());
    }

    const onUserBranchesSubmit = async (data, e) => {

        await dispatch(actions.getAllUserBranches());
    }

    const onDisplayAllMenus = async (menuId) => {

        //  await dispatch(actions.getAllPasswordProfilesByProfileId(passwordProfileId));
    }

    const updateSortString = async (val) => {
    }


    function renderMenuSearchCriteria() {

        let MenuId = <input className={errorsMenusSearch.userCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="menuId" required=""
            placeholder="--Menu Id--"
            name='menuId'
            {...registerMenusSearch("menuId", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuId}
        />

        let MenuType = <input className="form-control fw-bold"
            placeholder="--Menu Type--"
            id="menuType"
            name="menuType"
            {...registerMenusSearch("menuType", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuType}
        />

        let MenuParentId = <input className='form-control fw-bold'
            id="menuParentId" required=""
            placeholder="--Menu Parent Id--"
            name='menuParentId'
            {...registerMenusSearch("menuParentId", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuParentId}
        />

        let MenuName = <input className="form-control fw-bold"
            placeholder="--Menu Name--"
            id="menuName"
            name="menuName"
            {...registerMenusSearch("menuName", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuName}
        />

        let ModuleCode = <input className='form-control fw-bold'
            id="moduleCode" required=""
            placeholder="--Module Code--"
            name='moduleCode'
            {...registerMenusSearch("moduleCode", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.moduleCode}
        />

        let MenuIconYn = <input className="form-control fw-bold"
            placeholder="--Menu Icon Yn--"
            id="menuIconYn"
            name="menuIconYn"
            {...registerMenusSearch("menuIconYn", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuIconYn}
        />

        let MenuPageCode = <input className='form-control fw-bold'
            id="menuPageCode" required=""
            placeholder="--Menu Page Code--"
            name='menuPageCode'
            {...registerMenusSearch("menuPageCode", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuPageCode}
        />

        let MenuFont = <input className="form-control fw-bold"
            placeholder="--Menu Font--"
            id="menuFont"
            name="menuFont"
            {...registerMenusSearch("menuFont", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuFont}
        />

        let MenuCreatedBy = <input className='form-control fw-bold'
            id="menuCreatedBy" required=""
            placeholder="--Menu Created By--"
            name='menuCreatedBy'
            {...registerMenusSearch("menuCreatedBy", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuCreatedBy}
        />

        let MenuToolTip = <input className='form-control fw-bold'
            id="menuToolTip" required=""
            placeholder="--Menu Tool Tip--"
            name='menuToolTip'
            {...registerMenusSearch("menuToolTip", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuToolTip}
        />

        let MenuHelp = <input className="form-control fw-bold"
            placeholder="--Menu Help--"
            id="menuHelp"
            name="menuHelp"
            {...registerMenusSearch("menuHelp", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuHelp}
        />

        let MenuShortCutKey = <input className='form-control fw-bold'
            id="menuShortCutKey" required=""
            placeholder="--Menu Short Cut Key--"
            name='menuShortCutKey'
            {...registerMenusSearch("menuShortCutKey", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuShortCutKey}
        />

        let UpdatedBy = <input className="form-control fw-bold"
            placeholder="--Updated By--"
            id="updatedBy"
            name="updatedBy"
            {...registerMenusSearch("updatedBy", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.updatedBy}
        />



        let MenuCreatedDt = <input className='form-control fw-bold'
            type="date" id="menuCreatedDt" required=""
            placeholder="Menu Created Dt"
            name='menuCreatedDt'
            {...registerMenusSearch("menuCreatedDt", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuCreatedDt}
        />
        let UpdatedDt = <input className='form-control fw-bold'
            type="date" id="updatedDt" required=""
            placeholder="Updated Dt"
            name='updatedDt'
            {...registerMenusSearch("updatedDt", { min: { value: groupMenus.issueFromDate, message: "This Date should be greater than or equal to Issue From Date" }, onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.updatedDt}
        />

        let MenuDisplayName = <input className="form-control fw-bold"
            placeholder="--Menu Display Name--"
            id="menuDisplayName"
            name="menuDisplayName"
            {...registerMenusSearch("menuDisplayName", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuDisplayName}
        />

        let MenuUrl = <input className={errorsMenusSearch.userCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="menuUrl" required=""
            placeholder="--Menu Url--"
            name='menuUrl'
            {...registerMenusSearch("menuUrl", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.menuUrl}
        />

        let SequenceNo = <input className="form-control fw-bold"
            placeholder="--Sequence No--"
            id="sequenceNo"
            name="sequenceNo"
            {...registerMenusSearch("sequenceNo", { onChange: (value) => handleMenusSearch(value) })}
            value={groupMenus.sequenceNo}
        />



        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation"
                    onSubmit={onSubmitData(onMenusSubmit, onErrorMenu)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetGroupMenusSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu ID </label>
                            {MenuId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Type </label>
                            {MenuType}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Parent ID </label>
                            {MenuParentId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Name</label>
                            {MenuName}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Module Code</label>
                            {ModuleCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Icon Yn </label>
                            {MenuIconYn}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Page Code </label>
                            {MenuPageCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Font</label>
                            {MenuFont}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Created By </label>
                            {MenuCreatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Created Dt </label>
                            {MenuCreatedDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Tool Tip</label>
                            {MenuToolTip}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Help</label>
                            {MenuHelp}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Short Cut Key </label>
                            {MenuShortCutKey}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Updated By </label>
                            {UpdatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Updated Dt </label>
                            {UpdatedDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Display Name </label>
                            {MenuDisplayName}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Menu Url </label>
                            {MenuUrl}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Sequence No </label>
                            {SequenceNo}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div id="tooltip-container2">
                            <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        </div>
                    </div>
                </form>

            </>
        )


    }

    function renderMenuListing() {

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div>

                    <div className="table-responsive">
                        <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                            <thead>
                                <tr>
                                    <th onClick={() => updateSortString('Actions')}>Actions ⬇️ </th>
                                    <th onClick={() => updateSortString('MenuId')}> Menu Id ⬇️ </th>
                                    <th onClick={() => updateSortString('MenuType')}> Menu Type ⬇️</th>
                                    <th onClick={() => updateSortString('MenuParentId')}>Menu Parent Id ⬇️</th>
                                    <th onClick={() => updateSortString('MenuName')}>Menu Name ⬇️</th>
                                    <th onClick={() => updateSortString('ModuleCode')}> Module Code ⬇️</th>
                                    <th onClick={() => updateSortString('MenuIconYn')}>Menu Icon Yn ⬇️</th>
                                    <th onClick={() => updateSortString('MenuPageCode')}>Menu Page Code ⬇️</th>
                                    <th onClick={() => updateSortString('MenuFont')}>Menu Font ⬇️</th>
                                    <th onClick={() => updateSortString('MenuCreatedBy')}>Menu Created By ⬇️</th>
                                    <th onClick={() => updateSortString('MenuCreatedDt')}>Menu Created Dt ⬇️</th>
                                    <th onClick={() => updateSortString('MenuToolTip')}>Menu Tool Tip ⬇️</th>
                                    <th onClick={() => updateSortString('MenuHelp')}>Menu Help ⬇️</th>
                                    <th onClick={() => updateSortString('MenuShortCutKey')}>Menu Short Cut Key ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedBy')}>Updated By ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedDt')}>Updated Dt ⬇️</th>
                                    <th onClick={() => updateSortString('MenuDisplayName')}>Menu Display Name ⬇️</th>
                                    <th onClick={() => updateSortString('MenuUrl')}>Menu Url ⬇️</th>
                                    <th onClick={() => updateSortString('SequenceNo')}>Sequence No ⬇️</th>

                                </tr>
                            </thead>
                            <tbody>

                                {

                                    menusListing.searchResult.length > 0 && menusListing.searchResult.map((searchResult, index) => (

                                        <tr >
                                            <td >
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" >
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                            </td>
                                            <td> {searchResult.menuId} </td>
                                            <td> {searchResult.menuType} </td>
                                            <td> {searchResult.menuParentId} </td>
                                            <td> {searchResult.menuName} </td>
                                            <td> {searchResult.moduleCode} </td>
                                            <td> {searchResult.menuIconYn} </td>
                                            <td> {searchResult.menuPageCode} </td>
                                            <td> {searchResult.menuFont} </td>
                                            <td> {searchResult.menuCreatedBy} </td>
                                            <td> {searchResult.menuCreatedDt} </td>
                                            <td> {searchResult.menuToolTip} </td>
                                            <td> {searchResult.menuHelp} </td>
                                            <td> {searchResult.menuShortCutKey} </td>
                                            <td> {searchResult.updatedBy} </td>
                                            <td> {searchResult.updatedDt} </td>
                                            <td> {searchResult.menuDisplayName} </td>
                                            <td> {searchResult.menuUrl} </td>
                                            <td> {searchResult.sequenceNo} </td>

                                        </tr>

                                    ))}

                            </tbody>
                        </table>
                    </div>

                </div>



            </>
        )

    }

    function renderGroupSearchCriteria() {

        let GroupId = <input className={errorsMenusSearch.groupId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="groupId" required=""
            placeholder="--Group Id--"
            name='groupId'
            {...registerGroupsSearch("groupId", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.groupId}
        />

        let CompanyId = <input className="form-control fw-bold"
            placeholder="--Company Id--"
            id="companyId"
            name="companyId"
            {...registerGroupsSearch("companyId", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.companyId}
        />

        let GorupCode = <input className='form-control fw-bold'
            id="gorupCode" required=""
            placeholder="--Gorup Code--"
            name='gorupCode'
            {...registerGroupsSearch("gorupCode", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.gorupCode}
        />

        let GroupName = <input className="form-control fw-bold"
            placeholder="--Group Name--"
            id="groupName"
            name="groupName"
            {...registerGroupsSearch("groupName", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.groupName}
        />

        let GroupCreatedBy = <input className='form-control fw-bold'
            id="groupCreatedBy" required=""
            placeholder="--Group Created By--"
            name='groupCreatedBy'
            {...registerGroupsSearch("groupCreatedBy", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.groupCreatedBy}
        />

        let GroupUpdatedBy = <input className="form-control fw-bold"
            placeholder="--Updated By--"
            id="groupUpdatedBy"
            name="groupUpdatedBy"
            {...registerGroupsSearch("groupUpdatedBy", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.groupUpdatedBy}
        />

        let GroupCreatedDt = <input className='form-control fw-bold'
            type="date" id="groupCreatedDt" required=""
            placeholder="Group Created Dt"
            name='groupCreatedDt'
            {...registerGroupsSearch("groupCreatedDt", { onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.groupCreatedDt}
        />
        let GroupUpdatedDt = <input className='form-control fw-bold'
            type="date" id="groupUpdatedDt" required=""
            placeholder=" Group Updated Dt"
            name='groupUpdatedDt'
            {...registerGroupsSearch("groupUpdatedDt", { min: { value: groupMenus.groupUpdatedDt, }, onChange: (value) => handleGroupsSearch(value) })}
            value={groupMenus.groupUpdatedDt}
        />

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation"
                    onSubmit={handleGroupsSubmitData(onGroupsSubmit, onErrorGroup)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetGroupMenusSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Id</label>
                            {GroupId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Company Id</label>
                            {CompanyId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Gorup Code</label>
                            {GorupCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Name</label>
                            {GroupName}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Created By</label>
                            {GroupCreatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Group Updated By</label>
                            {GroupUpdatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Created Dt</label>
                            {GroupCreatedDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label"> Group Updated Dt</label>
                            {GroupUpdatedDt}
                        </div>
                    </div>



                    <div className="row g-2">
                        <div id="tooltip-container2">
                            <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        </div>
                    </div>
                </form>

            </>
        )

    }

    function renderGroupListing() {


        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div>

                    <div className="table-responsive">
                        <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                            <thead>
                                <tr>
                                    <th onClick={() => updateSortString('Actions')}>Actions ⬇️ </th>
                                    <th onClick={() => updateSortString('GroupId')}>Group Id ⬇️ </th>
                                    <th onClick={() => updateSortString('CompanyId')}>Company Id ⬇️</th>
                                    <th onClick={() => updateSortString('GorupCode')}>Gorup Code ⬇️</th>
                                    <th onClick={() => updateSortString('GroupName')}>Group Name ⬇️</th>
                                    <th onClick={() => updateSortString('GroupCreatedBy')}>Group CreatedBy ⬇️</th>
                                    <th onClick={() => updateSortString('GroupCreatedDt')}>Group CreatedDt ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedDt')}>Updated Dt ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedBy')}>Updated By ⬇️</th>

                                </tr>
                            </thead>
                            <tbody>

                                {

                                    groupsListing.searchResult.length > 0 && groupsListing.searchResult.map((searchResult, index) => (

                                        <tr >
                                            <td >
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" >
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                            </td>
                                            <td> {searchResult.groupId} </td>
                                            <td> {searchResult.companyId} </td>
                                            <td> {searchResult.gorupCode} </td>
                                            <td> {searchResult.groupName} </td>
                                            <td> {searchResult.groupCreatedBy} </td>
                                            <td> {searchResult.groupCreatedDt} </td>
                                            <td> {searchResult.updatedDt} </td>
                                            <td> {searchResult.updatedBy} </td>


                                        </tr>

                                    ))}

                            </tbody>
                        </table>
                    </div>

                </div>



            </>
        )

    }

    function renderGroupMenuSearchCriteria() {

        let GrpMenuId = <input className={errorsMenusSearch.grpMenuId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="grpMenuId" required=""
            placeholder="--Grp MenuId--"
            name='grpMenuId'
            {...registerGroupMenusSearch("grpMenuId", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.grpMenuId}
        />

        let GrpMenuGroupId = <input className="form-control fw-bold"
            placeholder="--Grp Menu Group Id--"
            id="grpMenuGroupId"
            name="grpMenuGroupId"
            {...registerGroupMenusSearch("grpMenuGroupId", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.grpMenuGroupId}
        />

        let GrpMenuIsActive = <input className='form-control fw-bold'
            id="grpMenuIsActive" required=""
            placeholder="--Grp Menu Is Active--"
            name='grpMenuIsActive'
            {...registerGroupMenusSearch("grpMenuIsActive", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.grpMenuIsActive}
        />

        let GrpMenuMenuId = <input className="form-control fw-bold"
            placeholder="--Grp Menu Menu Id--"
            id="grpMenuMenuId"
            name="grpMenuMenuId"
            {...registerGroupMenusSearch("grpMenuMenuId", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.grpMenuMenuId}
        />

        let GrpMenuVisibleYn = <input className='form-control fw-bold'
            id="grpMenuVisibleYn" required=""
            placeholder="--Grp Menu Visible Yn--"
            name='grpMenuVisibleYn'
            {...registerGroupMenusSearch("grpMenuVisibleYn", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.grpMenuVisibleYn}
        />

        let GrpMenuModuleId = <input className="form-control fw-bold"
            placeholder="--Grp Menu Module Id--"
            id="grpMenuModuleId"
            name="grpMenuModuleId"
            {...registerGroupMenusSearch("grpMenuModuleId", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.grpMenuModuleId}
        />

        let CreatedBy = <input className='form-control fw-bold'
            id="createdBy" required=""
            placeholder="--Created By--"
            name='createdBy'
            {...registerGroupMenusSearch("createdBy", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.createdBy}
        />

        let GroupMenuUpdatedBy = <input className="form-control fw-bold"
            placeholder="--Group Menu Updated By--"
            id="groupMenuUpdatedBy"
            name="groupMenuUpdatedBy"
            {...registerGroupMenusSearch("groupMenuUpdatedBy", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.groupMenuUpdatedBy}
        />

        let CreatedDt = <input className='form-control fw-bold'
            type="date" id="createdDt" required=""
            placeholder="Created Dt"
            name='createdDt'
            {...registerGroupMenusSearch("createdDt", { onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.createdDt}
        />
        let GroupMenuUpdatedDt = <input className='form-control fw-bold'
            type="date" id="groupMenuUpdatedDt" required=""
            placeholder=" Group Menu Updated Dt"
            name='groupMenuUpdatedDt'
            {...registerGroupMenusSearch("groupMenuUpdatedDt", { min: { value: groupMenus.groupMenuUpdatedDt, }, onChange: (value) => handleGroupMenusSearch(value) })}
            value={groupMenus.groupMenuUpdatedDt}
        />

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation"
                    onSubmit={handleGroupMenusSubmitData(onGroupMenusSubmit, onErrorGroupMenu)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetGroupMenusSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Grp Menu Id</label>
                            {GrpMenuId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Grp Menu Group Id</label>
                            {GrpMenuGroupId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Grp Menu Is Active</label>
                            {GrpMenuIsActive}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Grp Menu Menu Id</label>
                            {GrpMenuMenuId}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Grp Menu Visible Yn</label>
                            {GrpMenuVisibleYn}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Grp Menu Module Id</label>
                            {GrpMenuModuleId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Created By</label>
                            {CreatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Created Dt</label>
                            {CreatedDt}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Group Menu Updated By</label>
                            {GroupMenuUpdatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Group Menu Updated Dt</label>
                            {GroupMenuUpdatedDt}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div id="tooltip-container2">
                            <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        </div>
                    </div>
                </form>

            </>
        )



    }

    function renderGroupMenuListing() {

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div>

                    <div className="table-responsive">
                        <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                            <thead>
                                <tr>
                                    <th onClick={() => updateSortString('Actions')}>Actions ⬇️ </th>
                                    <th onClick={() => updateSortString('GrpMenuId')}>Grp Menu Id ⬇️ </th>
                                    <th onClick={() => updateSortString('GrpMenuGroupId')}>Grp Menu Group Id ⬇️</th>
                                    <th onClick={() => updateSortString('GrpMenuIsActive')}>Grp Menu Is Active ⬇️</th>
                                    <th onClick={() => updateSortString('GrpMenuMenuId')}>Grp Menu Menu Id ⬇️</th>
                                    <th onClick={() => updateSortString('GrpMenuVisibleYn')}>Grp Menu Visible Yn ⬇️</th>
                                    <th onClick={() => updateSortString('CreatedDt')}>Created Dt ⬇️</th>
                                    <th onClick={() => updateSortString('CreatedBy')}>Created By ⬇️</th>
                                    <th onClick={() => updateSortString('GrpMenuModuleId')}>Grp Menu Module Id ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedDt')}>Updated Dt ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedBy')}>Updated By ⬇️</th>

                                </tr>
                            </thead>
                            <tbody>

                                {

                                    groupmenusListing.searchResult.length > 0 && groupmenusListing.searchResult.map((searchResult, index) => (

                                        <tr >
                                            <td >
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" >
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                            </td>
                                            <td> {searchResult.grpMenuId} </td>
                                            <td> {searchResult.grpMenuGroupId} </td>
                                            <td> {searchResult.grpMenuIsActive} </td>
                                            <td> {searchResult.grpMenuMenuId} </td>
                                            <td> {searchResult.grpMenuVisibleYn} </td>
                                            <td> {searchResult.createdDt} </td>
                                            <td> {searchResult.createdBy} </td>
                                            <td> {searchResult.grpMenuModuleId} </td>
                                            <td> {searchResult.updatedDt} </td>
                                            <td> {searchResult.updatedBy} </td>

                                        </tr>

                                    ))}

                            </tbody>
                        </table>
                    </div>

                </div>



            </>
        )


    }

    function renderModuleSearchCriteria() {
        let SecModuleCode = <input className={errorsMenusSearch.secModuleCode ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="secModuleCode" required=""
            placeholder="--Sec Module Code--"
            name='secModuleCode'
            {...registerModulesSearch("secModuleCode", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.secModuleCode}
        />

        let SecModuleName = <input className="form-control fw-bold"
            placeholder="--Sec Module Name--"
            id="secModuleName"
            name="secModuleName"
            {...registerModulesSearch("secModuleName", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.secModuleName}
        />

        let SecModuleSystemId = <input className='form-control fw-bold'
            id="secModuleSystemId" required=""
            placeholder="--Sec Module System Id--"
            name='secModuleSystemId'
            {...registerModulesSearch("secModuleSystemId", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.secModuleSystemId}
        />

        let SecModuleId = <input className="form-control fw-bold"
            placeholder="--Sec Module Id--"
            id="secModuleId"
            name="secModuleId"
            {...registerModulesSearch("secModuleId", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.secModuleId}
        />

        let ModuleCreatedBy = <input className='form-control fw-bold'
            id="moduleCreatedBy" required=""
            placeholder="--Module Created By--"
            name='moduleCreatedBy'
            {...registerModulesSearch("moduleCreatedBy", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.moduleCreatedBy}
        />

        let ModuleUpdatedBy = <input className="form-control fw-bold"
            placeholder="--Module Updated By--"
            id="moduleUpdatedBy"
            name="moduleUpdatedBy"
            {...registerModulesSearch("moduleUpdatedBy", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.moduleUpdatedBy}
        />

        let ModuleCreatedDt = <input className='form-control fw-bold'
            type="date" id="moduleCreatedDt" required=""
            placeholder="Module Created Dt"
            name='moduleCreatedDt'
            {...registerModulesSearch("moduleCreatedDt", { onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.moduleCreatedDt}
        />
        let ModuleUpdatedDt = <input className='form-control fw-bold'
            type="date" id="moduleUpdatedDt" required=""
            placeholder=" Module Updated Dt"
            name='moduleUpdatedDt'
            {...registerModulesSearch("moduleUpdatedDt", { min: { value: groupMenus.moduleUpdatedDt, }, onChange: (value) => handleModulesSearch(value) })}
            value={groupMenus.moduleUpdatedDt}
        />

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation"
                    onSubmit={handleModulesSubmitData(onModulesSubmit, onErrorModule)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetGroupMenusSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Sec Module Code</label>
                            {SecModuleCode}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Sec Module Name</label>
                            {SecModuleName}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Sec Module System Id</label>
                            {SecModuleSystemId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Sec Module Id</label>
                            {SecModuleId}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Module Created By</label>
                            {ModuleCreatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Module Updated By</label>
                            {ModuleUpdatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Module Created Dt</label>
                            {ModuleCreatedDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Module Updated Dt</label>
                            {ModuleUpdatedDt}
                        </div>
                    </div>


                    <div className="row g-2">
                        <div id="tooltip-container2">
                            <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        </div>
                    </div>
                </form>

            </>
        )

    }

    function renderModuleListing() {

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div>

                    <div className="table-responsive">
                        <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                            <thead>
                                <tr>
                                    <th onClick={() => updateSortString('Actions')}>Actions ⬇️ </th>
                                    <th onClick={() => updateSortString('SecModuleCode')}>Sec Module Code ⬇️ </th>
                                    <th onClick={() => updateSortString('SecModuleName')}>Sec Module Name ⬇️</th>
                                    <th onClick={() => updateSortString('SecModuleSystemId')}>Sec Module System Id ⬇️</th>
                                    <th onClick={() => updateSortString('CreatedBy')}>Created By ⬇️</th>
                                    <th onClick={() => updateSortString('CreatedDt')}>Created Dt ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedBy')}>Updated By ⬇️</th>
                                    <th onClick={() => updateSortString('UpdatedDt')}>Updated Dt ⬇️</th>
                                    <th onClick={() => updateSortString('SecModuleId')}>Sec Module Id ⬇️</th>

                                </tr>
                            </thead>
                            <tbody>

                                {

                                    modulesListing.searchResult.length > 0 && modulesListing.searchResult.map((searchResult, index) => (

                                        <tr >
                                            <td >
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" >
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                            </td>
                                            <td> {searchResult.secModuleCode} </td>
                                            <td> {searchResult.secModuleName} </td>
                                            <td> {searchResult.secModuleSystemId} </td>
                                            <td> {searchResult.createdBy} </td>
                                            <td> {searchResult.createdDt} </td>
                                            <td> {searchResult.updatedBy} </td>
                                            <td> {searchResult.updatedDt} </td>
                                            <td> {searchResult.secModuleId} </td>

                                        </tr>

                                    ))}

                            </tbody>
                        </table>
                    </div>

                </div>



            </>
        )

    }

    function renderUserBranchesSearchCriteria() {

        let UsrCompanyId = <input className={errorsMenusSearch.usrCompanyId ? 'form-control is-invalid' : 'form-control fw-bold'}
            id="usrCompanyId" required=""
            placeholder="--Usr Company Id--"
            name='usrCompanyId'
            {...registerUserBranchesSearch("usrCompanyId", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrCompanyId}
        />

        let UsrId = <input className="form-control fw-bold"
            placeholder="--Usr Id--"
            id="usrId"
            name="usrId"
            {...registerUserBranchesSearch("usrId", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrId}
        />

        let UsrBrBranchId = <input className='form-control fw-bold'
            id="usrBrBranchId" required=""
            placeholder="--Usr Br Branch Id--"
            name='usrBrBranchId'
            {...registerUserBranchesSearch("usrBrBranchId", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrBranchId}
        />

        let UsrBrIsDefault = <input className="form-control fw-bold"
            placeholder="--Usr Br Is Default--"
            id="usrBrIsDefault"
            name="usrBrIsDefault"
            {...registerUserBranchesSearch("usrBrIsDefault", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrIsDefault}
        />

        let UsrBrIsActive = <input className='form-control fw-bold'
            id="usrBrIsActive" required=""
            placeholder="--Usr Br Is Active--"
            name='usrBrIsActive'
            {...registerUserBranchesSearch("usrBrIsActive", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrIsActive}
        />

        let UsrBrActiveFromDt = <input className='form-control fw-bold'
            type="date" id="usrBrActiveFromDt" required=""
            placeholder="Usr Br Active From Dt"
            name='usrBrActiveFromDt'
            {...registerUserBranchesSearch("usrBrActiveFromDt", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrActiveFromDt}
        />
        let UsrBrActiveToDt = <input className='form-control fw-bold'
            type="date" id="usrBrActiveToDt" required=""
            placeholder="Usr Br Active To Dt"
            name='usrBrActiveToDt'
            {...registerUserBranchesSearch("usrBrActiveToDt", { min: { value: groupMenus.groupMenuUpdatedDt, }, onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrActiveToDt}
        />

        let UsrBrCreatedBy = <input className='form-control fw-bold'
            id="usrBrCreatedBy" required=""
            placeholder="--Usr Br Created By--"
            name='usrBrCreatedBy'
            {...registerUserBranchesSearch("usrBrCreatedBy", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrCreatedBy}
        />

        let UsrBrUpdatedBy = <input className="form-control fw-bold"
            placeholder="--Usr Br Updated By--"
            id="usrBrUpdatedBy"
            name="usrBrUpdatedBy"
            {...registerUserBranchesSearch("usrBrUpdatedBy", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrUpdatedBy}
        />

        let UsrBrCreatedDt = <input className='form-control fw-bold'
            type="date" id="usrBrCreatedDt" required=""
            placeholder="UsrBrCreatedDt"
            name='usrBrCreatedDt'
            {...registerUserBranchesSearch("usrBrCreatedDt", { onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrCreatedDt}
        />
        let UsrBrUpdatedDt = <input className='form-control fw-bold'
            type="date" id="usrBrUpdatedDt" required=""
            placeholder="Usr Br Updated Dt"
            name='usrBrUpdatedDt'
            {...registerUserBranchesSearch("usrBrUpdatedDt", { min: { value: groupMenus.usrBrUpdatedDt, }, onChange: (value) => handleUserBranchesSearch(value) })}
            value={groupMenus.usrBrUpdatedDt}
        />

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <form className="form-group needs-validation"
                    onSubmit={handleUserBranchesSubmitData(onUserBranchesSubmit, onErrorUserBranch)} noValidate="noValidate">
                    <div className="row g-2">
                        <div className="mb-1 col-md-12">
                            <div className="btn-group float-end" id="tooltip-container2">
                                <div class="btn-group" role="group" aria-label="Second group">
                                    <button type="button" className="btn btn-danger"
                                        data-bs-container="#tooltip-container2" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Reset" onClick={() => onResetGroupMenusSearch()}> Reset <i className="mdi mdi-rotate-left"></i></button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Company Id</label>
                            {UsrCompanyId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Id</label>
                            {UsrId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Branch Id</label>
                            {UsrBrBranchId}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Is Default</label>
                            {UsrBrIsDefault}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Is Active</label>
                            {UsrBrIsActive}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Active From Dt</label>
                            {UsrBrActiveFromDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Active To Dt</label>
                            {UsrBrActiveToDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Created By</label>
                            {UsrBrCreatedBy}
                        </div>
                    </div>

                    <div className="row g-2">

                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Updated By</label>
                            {UsrBrUpdatedBy}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Created Dt</label>
                            {UsrBrCreatedDt}
                        </div>
                        <div className="mb-3 col-md-3">
                            <label htmlFor="inputState" className="form-label">Usr Br Updated Dt</label>
                            {UsrBrUpdatedDt}
                        </div>
                    </div>

                    <div className="row g-2">
                        <div id="tooltip-container2">
                            <button type="submit" className="btn btn-primary float-end"
                                data-bs-container="#tooltip-container2" data-bs-placement="bottom" title="Search" ><i className="dripicons-search"></i> Search</button>
                        </div>
                    </div>
                </form>

            </>
        )


    }

    function renderUserBranchesListing() {

        return (
            <>
                <ul className="nav nav-tabs nav-bordered mb-1">
                </ul>
                <div>

                    <div className="table-responsive">
                        <table id="scroll-horizontal-datatable" className="table w-100 nowrap resizeable_table_head">
                            <thead>
                                <tr>
                                    <th onClick={() => updateSortString('Actions')}>Actions ⬇️ </th>
                                    <th onClick={() => updateSortString('CompanyId')}> Company Id ⬇️ </th>
                                    <th onClick={() => updateSortString('UsrId')}>Usr Id ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrBranchId')}>Usr Br Branch Id ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrIsDefault')}>Usr Br Is Default ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrIsActive')}>Usr Br Is Active ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrActiveFromDt')}>Usr Br Active From Dt ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrActiveToDt')}>Usr Br Active To Dt ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrCreatedBy')}>Usr Br Created By ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrCreatedDt')}>Usr Br Created Dt ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrUpdatedBy')}>Usr Br Updated By ⬇️</th>
                                    <th onClick={() => updateSortString('UsrBrUpdatedDt')}>Usr Br Updated Dt ⬇️</th>

                                </tr>
                            </thead>
                            <tbody>

                                {

                                    userBranchesListing.searchResult.length > 0 && userBranchesListing.searchResult.map((searchResult, index) => (

                                        <tr >
                                            <td >
                                                <button type="button" className="btn btn-secondary btn-sm" data-bs-container="#tooltip-container2"
                                                    data-bs-toggle="tooltip" data-bs-placement="bottom" title="View" >
                                                    <i className="dripicons-preview"></i>
                                                </button>
                                            </td>
                                            <td> {searchResult.companyId} </td>
                                            <td> {searchResult.usrId} </td>
                                            <td> {searchResult.usrBrBranchId} </td>
                                            <td> {searchResult.usrBrIsDefault} </td>
                                            <td> {searchResult.usrBrIsActive} </td>
                                            <td> {searchResult.usrBrActiveFromDt} </td>
                                            <td> {searchResult.usrBrActiveToDt} </td>
                                            <td> {searchResult.usrBrCreatedBy} </td>
                                            <td> {searchResult.usrBrCreatedDt} </td>
                                            <td> {searchResult.updatedBy} </td>
                                            <td> {searchResult.updatedDt} </td>

                                        </tr>

                                    ))}

                            </tbody>
                        </table>
                    </div>

                </div>



            </>
        )


    }

    return (

        <>
            <div className="wrapper">
                <LeftSideMenu />
                <div class="content-page">

                    <TopBar />
                    <div class="content">
                        <DashboardTitle />
                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>Menus</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderMenuSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i> Menus Listing</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderMenuListing()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}


                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>Groups</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderGroupSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i> Groups Listing</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderGroupListing()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>Group Menus</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderGroupMenuSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i> Group Menus Listing</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderGroupMenuListing()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>Modules</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderModuleSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i> Modules Listing</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderModuleListing()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-primary float-start"><i className="mdi mdi-clipboard-text-search-outline me-1 mb-0"></i>User Branches</div>
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i>Search Criteria</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderUserBranchesSearchCriteria()}
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>}

                        {<div className="content">
                            <div className="row">
                                <div className="col-12">
                                    <div className="card ribbon-box">
                                        <div className="card-body">
                                            <div className="ribbon ribbon-success float-start"><i className="dripicons-list me-1"></i> User Branches Listing</div>
                                            <div className="btn-group float-end" id="tooltip-container2">

                                                <button className="btn btn-sm btn-light ms-1 btn-sm" type="button" id="searchcollapsableButton"
                                                    data-bs-toggle="collapse" data-bs-target="#CollapseSearchComponents"
                                                    aria-expanded="false" aria-controls="CollapseSearchComponents" onClick={() => onCollapseSearch()}>
                                                    <i className="mdi mdi-arrow-up-down"></i>
                                                </button>
                                            </div>
                                            <h5 className="text-primary float-end mt-0"> </h5>
                                            <div className="ribbon-content">
                                                {renderUserBranchesListing()}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>



        </>
    )
}